import React from 'react';
import { func, bool } from 'prop-types';
import { useDispatch } from 'react-redux';
import { useACSelectionBoxContext } from '../../autocode/ACContext/ACSelectionBoxContext';
import AutocodeSelectionAction from '../../autocode/AutocodeSelectionBox/AutocodeSelectionActions';
import {
  setEditTargetNode,
  setTempSelectedTargetForBuild } from '../../../actions/deActions/deBuildActions';

const UnsavedBuildContent = ({
  confirmNavigation,
  resetRouterLocation,
  routerLeaveModal,
}) => {
  const dispatch = useDispatch();
  const acSelContext = useACSelectionBoxContext();
  const {
    removeAllNodes,
  } = AutocodeSelectionAction(acSelContext.state, acSelContext.dispatch);

  const _handleNoClick = () => {
    if (routerLeaveModal) {
      resetRouterLocation();
    }
  };

  const _handleYesClick = () => {
    if (routerLeaveModal) {
      removeAllNodes();
      dispatch(setEditTargetNode(null))
      dispatch(setTempSelectedTargetForBuild(null))
      setTimeout(() => {
        confirmNavigation();
      }, 0)
    }
  };

  return (
    <div className="de__unsaved--body">
      <span>You have targets that have not been saved. Do you want to clear these targets and continue?</span>
      <div className="de__unsaved--actions">
        <button
          type="button"
          onClick={_handleNoClick}
          className="de--btn de--btn--outline__primary"
        >
          Cancel
        </button>
        <button
          type="button"
          onClick={_handleYesClick}
          className="de--btn de--btn__primary"
        >
          Clear Targets
        </button>
      </div>
    </div>
  );
};

UnsavedBuildContent.propTypes = {
  confirmNavigation: func,
  resetRouterLocation: func,
  routerLeaveModal: bool,
};

export default UnsavedBuildContent;
